/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const MessageCircleReply = [
  [
    "path",
    {
      d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
    }
  ],
  ["path", { d: "m10 15-3-3 3-3" }],
  ["path", { d: "M7 12h8a2 2 0 0 1 2 2v1" }]
];

export { MessageCircleReply as default };
//# sourceMappingURL=message-circle-reply.js.map
